"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Upload = /** @class */ (function () {
    function Upload(documentObject) {
        this.setUpload(documentObject);
    }
    Upload.prototype.setUpload = function (documentObject) {
        var inputs = documentObject.querySelectorAll('.js-upload');
        Array.prototype.forEach.call(inputs, function (input) {
            var label = input.nextElementSibling, labelVal = label.innerHTML;
            input.addEventListener('change', function (e) {
                var fileName = '';
                if (this.files && this.files.length > 1) {
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                }
                else {
                    fileName = e.target.value.split('\\').pop();
                }
                if (fileName)
                    label.innerHTML = fileName;
                else
                    label.innerHTML = labelVal;
            });
        });
    };
    return Upload;
}());
exports.default = Upload;
